import { render, staticRenderFns } from "./maintainCourse.vue?vue&type=template&id=78f60d66&"
import script from "./maintainCourse.vue?vue&type=script&lang=js&"
export * from "./maintainCourse.vue?vue&type=script&lang=js&"
import style0 from "./maintainCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports